import React from 'react';
import { Input, Button, Select } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { Logo } from 'assets/img';
import { AuthService } from 'services';
import { connect } from 'react-redux';

interface Props extends RootState {
	onClose?: any;
	dispatch?: any;
}

class ModalRegister extends React.Component<Props> {

	state = {
		form: {
			name: '',
	        email: '',
	        lastname: '',
	        password: '',
	        document: '',
	        phone: '',
	        tax_document: '',
	        password_confirmation: '',
	        document_type_id: Constants.DOCUMENT_TYPES.V
		},
		document_types: []
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await AuthService.getDocumentTypes();
		this.setState({
			document_types: res.document_types
		});
	}

	change = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (!this.state.form.document && [Constants.DOCUMENT_TYPES.V, Constants.DOCUMENT_TYPES.E].indexOf(this.state.form.document_type_id) != -1) {
			Globals.showError("El campo cédula es requerido");
			return;
		}

		if (!this.state.form.tax_document && [Constants.DOCUMENT_TYPES.J, Constants.DOCUMENT_TYPES.G].indexOf(this.state.form.document_type_id) != -1) {
			Globals.showError("El campo RIF es requerido");
			return;
		}

		const res: any = await AuthService.register({
			...this.state.form,
			referral_code: this.props.referral_code
		});
		await this.props.dispatch({
			type: 'SET_USER',
			payload: res.user
		});
		await this.props.dispatch({
			type: 'SET_REFERRAL_CODE',
			payload: null
		});
		this.props.onClose(true);
	}

	render() {
		return (
			<form id="modal-quotes-register" onSubmit={ this.submit }>
				<div className="text-center">
					<img src={ Logo } className="logo" />
				</div>
				<h3>Formulario de registro</h3>
				<h4>Datos de persona de contacto o empresa</h4>
				<div className="row">
					<div className="col-md-6">
						<Input
							color="white"
							value={ this.state.form.name }
							name="name" 
							placeholder="Nombre"
							onChange={ this.change } />
					</div>
					<div className="col-md-6">
						<Input
							color="white"
							value={ this.state.form.lastname }
							name="lastname" 
							placeholder="Apellido"
							onChange={ this.change } />
					</div>
					<div className="col-md-6">
						<div className="container-document">
							<div className="select-document">
								<Select
									placeholder="Tipo de Documento"
									name="document_type_id"
									onChange={ (e: any) => {
										this.setState({
											form: {
												...this.state.form,
												document_type_id: parseInt(e.target.value)
											}
										});
									} }
									value={ this.state.form.document_type_id }
									options={ this.state.document_types.map((i: any) => {
										return {
											value: i.id,
											label: i.name
										}
									}) } />
							</div>
							<div>
								{
									[Constants.DOCUMENT_TYPES.V, Constants.DOCUMENT_TYPES.E].indexOf(this.state.form.document_type_id) != -1 && (
										<Input
											color="white"
											value={ this.state.form.document }
											name="document" 
											placeholder="Cédula"
											onChange={ this.change } />
									)
								}
								{
									[Constants.DOCUMENT_TYPES.J, Constants.DOCUMENT_TYPES.G].indexOf(this.state.form.document_type_id) != -1 && (
										<Input
											color="white"
											value={ this.state.form.tax_document }
											name="tax_document" 
											placeholder="RIF"
											onChange={ this.change } />
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-6">
						<Input
							type="number"
							color="white"
							value={ this.state.form.phone }
							name="phone" 
							maxLength={ 11 }
							placeholder="Teléfono - Ej. 04121234567"
							onChange={ this.change } />
					</div>
					<div className="col-md-6">
						<Input
							color="white"
							value={ this.state.form.email }
							name="email" 
							placeholder="Correo"
							onChange={ this.change } />
					</div>
				</div>
				<h4>Contraseña</h4>
				<div className="row">
					<div className="col-md-6">
						<Input
							type="password"
							color="white"
							value={ this.state.form.password }
							name="password" 
							placeholder="Contraseña"
							onChange={ this.change } />
					</div>
					<div className="col-md-6">
						<Input
							type="password"
							color="white"
							value={ this.state.form.password_confirmation }
							name="password_confirmation" 
							placeholder="Repetir Contraseña"
							onChange={ this.change } />
					</div>
				</div>
				<div className="text-center">
					<button className="btn btn-login" type="submit">
						Guardar
					</button>
				</div>
			</form>
		)
	}
}

export default connect((state: RootState) => {
	return {
		referral_code: state.referral_code
	}
})(ModalRegister);